﻿{
  "version": 1,
  "gameId": "marpele",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "rerollCoins": 10, "rerollLimit": 2 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "marpele.rules.navigationLabel",
    "kickerKey": "marpele.rules.kicker",
    "titleKey": "marpele.rules.title",
    "summaryKey": "marpele.rules.summary",
    "sections": [
      { "id": "setup", "key": "marpele.rules.setup" },
      { "id": "enter", "key": "marpele.rules.enter" },
      { "id": "move", "key": "marpele.rules.move" },
      { "id": "jumps", "key": "marpele.rules.jumps" },
      { "id": "safety", "key": "marpele.rules.safety" },
      { "id": "finish", "key": "marpele.rules.finish" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {
    "boardThemes": [
      { "id": "classic", "nameKey": "marpele.theme.classic", "price": 0, "image": "/assets/boards/Snake&Ladder/marpele-board.jpg" },
      { "id": "retro-ladder", "nameKey": "marpele.theme.vintageBoard", "price": 90, "image": "/assets/boards/Snake&Ladder/Board00old.jpg" },
      { "id": "candy-climb", "nameKey": "marpele.theme.board3", "price": 120, "image": "/assets/boards/Snake&Ladder/provenance-review-placeholder.svg" },
      { "id": "forest-steps", "nameKey": "marpele.theme.board4", "price": 150, "image": "/assets/boards/Snake&Ladder/provenance-review-placeholder.svg" },
      { "id": "ocean-spiral", "nameKey": "marpele.theme.board6", "price": 180, "image": "/assets/boards/Snake&Ladder/provenance-review-placeholder.svg" },
      { "id": "sunset-slide", "nameKey": "marpele.theme.board8", "price": 210, "image": "/assets/boards/Snake&Ladder/provenance-review-placeholder.svg" },
      { "id": "royal-serpent", "nameKey": "marpele.theme.board9", "price": 240, "image": "/assets/boards/Snake&Ladder/provenance-review-placeholder.svg" },
      { "id": "cloud-ladder", "nameKey": "marpele.theme.board12", "price": 270, "image": "/assets/boards/Snake&Ladder/provenance-review-placeholder.svg" },
      { "id": "neon-viper", "nameKey": "marpele.theme.board13", "price": 300, "image": "/assets/boards/Snake&Ladder/Board13.jpg" },
      { "id": "desert-steps", "nameKey": "marpele.theme.board15", "price": 330, "image": "/assets/boards/Snake&Ladder/Board15.jpg" },
      { "id": "cosmic-coil", "nameKey": "marpele.theme.board18", "price": 370, "image": "/assets/boards/Snake&Ladder/Board18.jpg" },
      { "id": "volcano-run", "nameKey": "marpele.theme.board20", "price": 420, "image": "/assets/boards/Snake&Ladder/Board20.jpg" }
    ]
  }
}
